import { Fragment } from 'react'
import { BeforeLoginStepProps } from '../BeforeLoginStepper'
import {
  ApartmentInfoStep,
  //MediaStep,
  ConfirmationStep
} from './StepComponents'

const BeforeLoginSteps = (stepProps: BeforeLoginStepProps) => {
  return (
    <Fragment>
      <Fragment>
        <ApartmentInfoStep {...stepProps} />
        {/* <MediaStep {...stepProps} /> */}
        <ConfirmationStep {...stepProps} />
      </Fragment>
    </Fragment>
  )
}

export default BeforeLoginSteps
